import React from 'react';
import Loading from '../../Loading.js';
import { StartingHandChart } from 'mygame-components';
// import StartingHandChart from './StartingHandChart.js';
import moment from 'moment';
import { baseUrl, domain } from '../../../common/config.js';
import { apiService } from '../../../common/apiCallService';
import { processHoleCards, saveActivity } from '../../../common/commonService.js'
import { MissionProgressBar } from 'mygame-components';
import { getColor, getTextColor } from '../../../common/ThemeService.js';

class MissionTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            play: 'ideal',
            position: 'Early',
            open: false,
            loading: false,
            getHoleCards: false,
            hands: this.props.hands,
            beginMissson: this.props.beginMissson,
            handCount: {},
            holeCards: {},
            playerData: {},
            redHands: 0,
            greenHands: 0,
            totalHands: 0,
            progressplayed: 0,
            result: this.props.result,
            missionStatus: this.props.missionStatus,
            missionstartDate: this.props.missionstartDate
        }



    }
    onSelectChartOrPosition = (optionSelected, chartOrPos) => {
        if (chartOrPos === 'position') {
            saveActivity({
                hit_page: 'MissionTooManyHands',
                hit_type: 'EarlyLateSlider',
                hit_attribute1: this.state.position,
                hit_attribute2: optionSelected,
                hit_attribute3: this.state.play,
                hit_attribute4: this.state.missionStatus
            })
        } else {
            saveActivity({
                hit_page: 'MissionTooManyHands',
                hit_type: 'IdealActualSlider',
                hit_attribute1: this.state.play,
                hit_attribute2: optionSelected,
                hit_attribute3: this.state.position,
                hit_attribute4: this.state.missionStatus,
            })
        }

        this.setState({
            selected: true,
            [chartOrPos]: optionSelected
        })

        if (optionSelected == 'actual' && !this.state.getHoleCards) {
            this.setState({ getHoleCards: true })
            this.getHoleCards()
        }
        else if (this.state.getHoleCards) {
            let redHands = 0
                , greenHands = 0
                , totalHands = 0
                , progressplayed = 0
                , position = ['Early', 'Late'].indexOf(optionSelected) != -1 ? optionSelected : this.state.position
                , handCount = this.state.handCount
                , holeCards = this.state.playerData.reduce((acc, obj) => {
                    if (obj.playerPosition == position) acc.push(obj)
                    return acc
                }, [])

            Object.keys(handCount).forEach((key) => {
                // if (key == position) {
                greenHands = greenHands + handCount[key].played
                redHands = redHands + handCount[key].notPlayed
                progressplayed = progressplayed + handCount[key].progressplayed
                // }
            });
            totalHands = redHands + greenHands + progressplayed

            this.setState({ progressplayed, greenHands, redHands, holeCards, totalHands })
        }
    }

    getHoleCards = (missionstartDate = this.state.missionstartDate) => new Promise((resolve, reject) => {
        this.setState({ loading: true })
        apiService(baseUrl + '/missions/getMissionRecords', {
            'accountName': this.props.accountName,
            'selectedType': this.props.selectedType,
            'userType': localStorage.getItem('loggedInType'),
            'startDate': missionstartDate,
            'gameType': this.props.gameType
        }, (plydata) => {
            if (plydata) {
                new Promise((resolve, reject) => {
                    processHoleCards(plydata, this.state.hands, this.state.selectedType, this.state.position)
                        .then((tableData) => {
                            let redHands = 0
                                , greenHands = 0
                                , totalHands = 0
                                , progressplayed = 0
                                , handCount = tableData[0]

                            Object.keys(handCount).forEach((key) => {
                                // if (key == this.state.position) {
                                greenHands = greenHands + handCount[key].played
                                redHands = redHands + handCount[key].notPlayed
                                progressplayed = progressplayed + handCount[key].progressplayed
                                // }
                                totalHands = redHands + greenHands + progressplayed
                            });
                            if (tableData[2].length == 50) {
                                let result;
                                greenHands / 50 * 100 >= 80 ? result = 'success' : result = 'fail'
                                this.setState({ result: result })
                                this.setState({ missionStatus: 'Completed' })
                                if (this.props.missionStatus != 'Completed')
                                    saveActivity({
                                        hit_page: 'MissionTooManyHands', hit_type: 'MissionComplete',
                                        hit_attribute1: result,
                                        hit_attribute2: greenHands + redHands,
                                        hit_attribute3: greenHands,
                                        hit_attribute4: redHands,
                                    })
                            }
                            this.setState({ progressplayed, greenHands, redHands, totalHands })
                            this.setState({ handCount: tableData[0] })
                            this.setState({ holeCards: tableData[1] })
                            this.setState({ playerData: tableData[2] })
                            this.setState({ loading: false })
                        })
                        .catch((err) => {
                            this.setState({ loading: false })
                            throw new Error(err)
                        })
                })
            }

        }, (data) => {
            this.setState({ loading: false })
        })
    })

    startMission = () => {
        this.setState({ open: false, missionStatus: 'Inprogress' })
        let missionstartDate = moment.utc().format('YYYY-MM-DD HH:mm:ss')
        saveActivity({
            hit_page: 'MissionTooManyHands', hit_type: 'ReportCardBeginMission',
            hit_attribute1: this.props.missionName,
            hit_attribute2: this.props.points,
            hit_attribute3: this.props.medal,
        })
        this.setState({ open: false })
        this.setState({ missionstartDate: missionstartDate })
        this.setState({ loading: true })
        apiService(baseUrl + '/missions/startMission', {
            'missionRestartDate': missionstartDate,
            'accountName': this.props.accountName,
            'missionName': this.props.missionName,
            'selectedType': this.props.selectedType,
            "status": 'Inprogress',
            "userType": localStorage.getItem('loggedInType')
        }, (data) => {
            this.getHoleCards()
            this.setState({ beginMissson: true })
        }, (data) => {
            this.setState({ loading: false })
        })
    }

    openModal = () => {
        window.scrollTo(0, 0);
        this.setState({ open: true })
    }


    restartMission = () => {
        this.setState({
            loading: true,
            missionStatus: "Inprogress"
        })
        let missionRestartDate = moment.utc().format('YYYY-MM-DD HH:mm:ss')
        saveActivity({
            hit_page: 'MissionTooManyHands', hit_type: 'ReportCardRestartMission',
            hit_attribute1: this.state.result,
        })
        apiService(baseUrl + '/missions/restartMission', {
            'missionRestartDate': missionRestartDate,
            'accountName': this.props.accountName,
            'missionName': this.props.missionName,
            'selectedType': this.props.selectedType,
            "status": 'Inprogress',
            "greenHands": this.state.greenHands + this.state.progressplayed,
            "redHands": this.state.redHands,
            "totalHandsPlayed": this.state.totalHands,
            "startDate": this.props.missionstartDate,
            'currentMissionStatus': 'Cancelled',
            'userType': localStorage.getItem('loggedInType'),
            'result': ''
        }, (data) => {
            this.getHoleCards(missionRestartDate)
            this.setState({ missionstartDate: missionRestartDate })
            this.setState({ beginMissson: true })
        }, (data) => {
            this.setState({ loading: false })
        })

    }
    endMission = (result, greenHands, redHands) => {
        this.setState({ loading: true })
        saveActivity({
            hit_page: ' MissionTooManyHands', hit_type: 'EndMissionButton',
            hit_attribute1: this.state.result,
        })

        apiService(
            baseUrl + '/missions/updateMission',
            {
                'accountName': this.props.accountName,
                'missionName': this.props.missionName,
                'selectedType': this.props.selectedType,
                "currentMissionStatus": 'EndMission',
                'userType': localStorage.getItem('loggedInType'),
                'startDate': this.props.missionstartDate
            },
            data => this.props.goBack(),
            err => this.setState({ loading: false })
        )
    }

    render() {
        const themeColor = getColor()
        const themeTextColor = getTextColor()
        let charts = [{ type: 'ideal', datae2e: 'idealVal' }, { type: 'actual', datae2e: 'actualVal' }]
            , positions = [{ type: 'Early', datae2e: 'earlyPos' }, { type: 'Late', datae2e: 'latePos' }]
            , showModal = this.state.open ? 'displayBlock' : 'displayNone'
            , { play, holeCards, playerData, hands, redHands, greenHands
                , totalHands, beginMissson, progressplayed } = this.state
            , isPlayerData = Object.keys(playerData).length > 0 ? true : false

        return (
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 cards" style={{align:'center'}}>
                {this.state.loading ? <Loading /> : null}
                <div className={"missonmodal " + showModal}>
                    <div className='modalContent respPadding'>
                        <center>
                            <img src={"//" + domain + "/images/common/missions/startMission.png"} alt="starting_Hand_Medal" style={{ width: '203.75px', height: '169.83px' }} />
                        </center>
                        <div className='b' style={{ paddingTop: '15px' }}><center>THE MISSION</center></div>
                        <div className='font15' style={{ color: 'black' }}><center>Starting hands, play in the green</center></div>
                        <div style={{ border: '0.7px solid #D4D4D4', marginTop: '14px', marginBottom: '9px' }}></div>
                        <div style={{ padding: '0 12px', color: '#555555c7' }} className='font15'>
                            <p className="missionlist">Your next 50 hands will be recorded & displayed in ‘your play charts’ </p>
                            <p className="missionlist">Compare your play with the ideal play </p>
                            <p className="missionlist">To complete this mission play the next 50 hands in the green and watch you game improve!</p>
                        </div>
                        <button data-e2e="startMission" className='missionbtn beginMission dialobgButton' style={{ marginTop: '18px' }} onClick={this.startMission}>GOT IT, THANKS</button>
                    </div>
                </div>

                <div className="row" style={{ paddingTop: '12px' }}>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 positions"> Hand Charts</div>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 positions" >
                        <span className="play">
                            {charts.map((play, index) =>
                                <div data-e2e={play.datae2e} key={index} className={`normalTextSize defplaybtns ptr ${this.state.play === play.type && 'activePlaybtn'}`}
                                    style={this.state.play === play.type ?
                                        {
                                            backgroundColor: themeColor,
                                            color: themeTextColor,
                                        }
                                        : {}}
                                    onClick={() => this.onSelectChartOrPosition(play.type, 'play')}>{play.type.toUpperCase()}</div>
                            )}
                        </span>
                    </div>
                </div>
                <div className="row" style={{ marginTop: '10px' }}>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 positions">Positions </div>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 positions">
                        <span className="play">
                            {positions.map((position, index) =>
                                <div data-e2e={position.datae2e} key={index} className={`normalTextSize defplaybtns ptr ${this.state.position === position.type && 'activePlaybtn'}`}
                                    style={this.state.position === position.type ?
                                        {
                                            backgroundColor: themeColor,
                                            color: themeTextColor,
                                        }
                                        : {}}
                                    onClick={() => this.onSelectChartOrPosition(position.type, 'position')}>{position.type.toUpperCase()}</div>
                            )}
                        </span>
                    </div>
                </div>
                <div style={{ paddingTop: '11px' }}>
                    {Object.keys(hands).length > 0 &&
                        <StartingHandChart
                            Loading={Loading}
                            hands={hands}
                            position={this.state.position}
                            play={play}
                            holeCards={holeCards}
                        />}
                </div>
                <div className={`row  b missionTableFont ${beginMissson ? `mt9` : isPlayerData && this.state.play === 'actual' ? `mt5` : `mt9`}`}>
                    <div className="col-lg-12" style={{ marginTop: totalHands == 50 && '5px' }}>
                        {beginMissson ?
                            totalHands == 50
                                ? `STARTING HANDS MISSION COMPLETE`
                                : `MISSION IN PROGRESS` :
                            isPlayerData && this.state.play === 'actual' ? `YOUR PLAY TO DATE` : `THE MISSION`}
                    </div>
                </div>
                {this.state.play === 'ideal' &&
                    <div className={`row mt9 b missionTableFont ${beginMissson ? `pb14` : `zeroPad`}`}>
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"><i className="fa colorRect"></i></div>
                        <div className="col-xs-10 col-sm-11 col-md-11 col-lg-11" style={{ paddingLeft: '12px', paddingTop: '2.5px' }}>
                            Play 50 hands in the Green
                        </div>
                    </div>}

                {this.state.play === 'actual' &&
                    isPlayerData
                    ? <div className="row b missionTableFont" style={{ marginTop: '0', fontWeight: '500' }}>
                        <div>
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                {beginMissson ?
                                    totalHands == 50
                                        ? `Score: B - You Played ${greenHands + progressplayed} Green & ${redHands} Red`
                                        : `Try to play 50 hands in the Green`
                                    : `Analysis of your last 1000 hands`}
                            </div>
                            <div className="row b missionTableFont" style={{ margin: '0', fontWeight: '500' }}>
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <MissionProgressBar
                                        greenHands={greenHands}
                                        redHands={redHands}
                                        totalHands={totalHands}
                                        progressplayed={progressplayed}
                                        handsTObePlayed={beginMissson ? 50 : 1000}
                                        missionName={this.props.missionName}
                                        points={this.props.points}
                                        beginMissson={beginMissson}
                                    />
                                </div>
                            </div>
                            {totalHands == 50
                                ?
                                <div className="row " style={{ margin: 0, marginBottom: '17px', marginTop: '3px' }}>
                                    <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5" style={{ width: 'fit-content' }}>
                                        <button className="b restartMissionBtn" onClick={this.restartMission}
                                            style={{ backgroundColor: '#EB602E' }}>RESTART</button>
                                    </div>
                                    <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5" style={{ paddingLeft: 0 }}>
                                        <button className='b restartMissionBtn' onClick={this.endMission}
                                            style={{ backgroundColor: 'white', color: '#020202' }}>END MISSION</button>
                                    </div>
                                </div>
                                :
                                <div>
                                    <div className="row b missionTableFont" style={{ margin: 0, marginTop: '5px', marginBottom: '5px' }}>
                                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"><i className="fa colorRect"></i></div>
                                        <div className="col-xs-10 col-sm-11 col-md-11 col-lg-11" style={{ paddingLeft: '12px' }}>
                                            {greenHands}<span className={beginMissson ? `inlineDisplay` : `displayNone`}> / {beginMissson ? 50 : 1000}</span> Hands Played correctly
                                        </div>
                                    </div>
                                    <div className={`row b missionTableFont ${beginMissson ? `pb14` : `zeroPad`}`} style={{ margin: 0 }}>
                                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"><i className="fa colorRect" style={{ background: '#FD5B65' }}></i></div>
                                        <div className="col-xs-10 col-sm-11 col-md-11 col-lg-11" style={{ paddingLeft: '12px' }}>
                                            {redHands}<span className={beginMissson ? `inlineDisplay` : `displayNone`}> / {beginMissson ? 50 : 1000}</span> Hands Played  incorrectly
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    : beginMissson && this.state.play === 'actual' &&
                    <span>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ padding: '0' }}>
                            Try to play 50 hands in the Green
                        </div>
                        <div className='inittrackedStatus' style={{ marginLeft: '0', marginRight: '0' }}><i className="fa fa-info-circle"></i>
                            &nbsp;&nbsp;We haven’t tracked any of your hands yet, check back soon to review your play!
                        </div>
                    </span>}


                <div >
                    {!beginMissson &&
                        <button data-e2e="beginMission" className={`pulseBeginMissionbutton missionbtn beginMission ${!beginMissson && this.state.play === 'ideal' && 'mt7'}`} style={{ marginBottom: '17px' }} onClick={this.openModal}>
                            BEGIN MISSION
                        </button>}
                    <button className='missionbtn beginMission displayUptoTab' style={{ marginTop: '0', marginBottom: '15px' }} onClick={this.props.learnPositions}>
                        LEARN ABOUT POSITIONS
                    </button>
                </div>
            </div>
        )
    }
}

export default MissionTable





/** WEBPACK FOOTER **
 ** ./src/components/ReportCard/Missions/MissionTable.js
 **/